






























































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
const Creditors = namespace("CreditorsModule");

@Component({
  name: "CreditorDetails",
})
export default class CreditorDetails extends Vue {
  @Creditors.State
  public creditorData!: Array<any>;

  @Creditors.Action
  public retrieveCreditorById!: (params: number) => Promise<any>;

  public creditor = {
    AdmNr: 0,
    Creditor: 0,
    Name: "",
    SearchCode: "",
    Country: "",
    PostalCode: "",
    Address1: "",
    City: "",
    Telephone: "",
    ContactEmail: "",
    Category: "HANDEL",
    BankInfo: [
      {
        BankAccType: "",
        BankAccNr: "",
        BankCurrCode: "",
        BankTypePrimary: 0,
        BankName: "",
        BankSwiftAddress: "",
      },
    ],
    CustomField: {
      MainContactName: "",
      MainContactEmail: "",
      RegisterName: "",
      InvoiceType: [],
    },
  };
  backToCreditor() {
    this.$router.push({ name: "Creditor" });
  }
  getCreditorDetailData() {
    this.retrieveCreditorById(parseInt(this.$route.params.creditorId)).then(
      (response) => {
        this.creditor = response;
        if (!response.CustomField) {
          response.CustomField = {
            MainContactName: "",
            MainContactEmail: "",
            RegisterName: "",
            InvoiceType: [],
          };
        }
        this.creditor = response;
      }
    );
  }
  created() {
    this.getCreditorDetailData();
  }
}
